// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.desc[data-v-283bcf00] {\n  color: #999;\n  font-size: 12px;\n  line-height: 16px;\n}\n.el-input-number.el-input-number--small[data-v-283bcf00] {\n  width: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
